import axios from 'axios';

const actions = {
  async getData({ context }, params) {
    try {
      const res = await axios.post(`${this.state.API_URL}/laporan_kas.php`, params);
      return res.data;
    } catch (error) {
      return error;
    }
  },
   

 
};
const mutations = {};
const state = {};
export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
